import(/* webpackMode: "eager", webpackExports: ["RoomActions"] */ "/app/app/r/[slug]/room-actions.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
